module.exports = {
    id: 1,
    name: "移动",
    type: "register",
    form: [
        {
            label: "保卡卡密",
            prop: "card_secret",
            obj: "card",
            type: "input"
        },
        {
            label: "卡号",
            prop: "card_num",
            obj: "card",
            type: "input"
        },
        {
            label: "卡密商家",
            prop: "group_name",
            obj: "card",
            type: "input"
        },
        {
            label: "子险种",
            prop: "card_name",
            obj: "card",
            type: "input"
        },

        {
            label: "子方案号",
            prop: "zifangan",
            obj: "card",
            type: "input"
        },

        {
            label: "手机正面图",
            prop: "tem_img",
            obj: "order",
            type: "img",
            watermark: true
        },
        {
            label: "是否新旧机",
            prop: "is_new_name",
            obj: "order",
            type: "div"
        },
       {
            label: "上传日期",
            prop: "add_date",
            obj: "order",
            type: "div"
        },
        {
            label: "手机号码",
            prop: "phone",
            obj: "order",
            type: "input"
        },


        {
            label: "手机品牌",
            prop: "brandYd",
            obj: "order",
            type: "div"
        },
        {
            label: "手机型号",
            prop: "modelYd",
            obj: "order",
            type: "div"
        },
        {
            label: "IMEI码",
            prop: "imei",
            obj: "order",
            type: "input"
        },
        {
            label: "手机规格",
            prop: "ramlYd",
            obj: "order",
            type: "div"
        },
        {
            label: "审核结果",
            prop: "exa_status",
            obj: "order",
            type: "radio",
            optListName: "statusList",
            optLabel: "name",
            optValue: "status",
            relate: "dateRange2",
            hx: "hx"
        },


        {
            label: "回复内容",
            prop: "fail_exp",
            obj: "order",
            type: "textarea"
        },


        {
            label: "跟进业务员",
            prop: "group_remark",
            obj: "order",
            type: "input"
        },

    ],
    tableColumns: [
        {
            slotName: "headimg"
        },
        {
            label: "注册者昵称",
            prop: "nickname"
        },
        {
            label: "注册人名称",
            prop: "name"
        },
        {
            label: "手机号码",
            prop: "phone"
        },
        {
            label: "商家名称",
            prop: "group_name"
        },
        {
            label: "省份",
            prop: "province"
        },
        {
            label: "城市",
            prop: "city"
        },
        {
            label: "区县",
            prop: "district"
        },
        {
            label: "分销商",
            prop: "fxs_name"
        },
        {
            label: "店铺名称",
            prop: "shop_name"
        },
        // {
        //     slotName: "operation"
        // }
    ],
    piccCallbackType: 1
}
